import request from '../../src/state/modules/axios'


export function sendSmsToUser(data) {
    return request({
        url:'/api/send-test-sms',
        method: 'post',
        data,
    })
}

export function checkSmsCode(data){
    return request({
        url: '/api/check-sms-code',
        method:'post',
        data,
    })
}

export function getPersonalInformation(params) {
    return request({
        url: '/api/get-test-information',
        method:'get',
        params,
    })
}

export function getTestPersonalInformation(params) {
    return request({
        url: '/api/vacancy/get-test-information',
        method:'get',
        params,
    })
}
